import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { assetsManagementActions as actions, notificationActions } from '../actions';
import { assetsManagementService } from '../services';

/* Add Assets Sagas */
function* handleAddAssetsRequest() {
    const action = yield take(actions.addAssetsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.addAssets, dataParams);
        if (res.isError) {
            yield put(actions.addAssetsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addAssetsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addAssetsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get All Assets Sagas */
function* handleGetAllAssetsListRequest() {
    const action = yield take(actions.getAllAssetsListRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.getAllAssetsList, dataParams);
        if (res.isError) {
            yield put(actions.getAllAssetsListError(res));

        } else {
            yield put(actions.getAllAssetsListSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllAssetsListError());
    }
}

/* Get Assets By Department Sagas */
function* handleGetAssetsRequest() {
    const action = yield take(actions.getAssetsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.getAssets, dataParams);
        if (res.isError) {
            yield put(actions.getAssetsError(res));

        } else {
            yield put(actions.getAssetsSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAssetsError());
    }
}

/* Update Assets Sagas */
function* handleUpdateAssetsRequest() {
    const action = yield take(actions.updateAssetsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.updateAssets, dataParams);
        if (res.isError) {
            yield put(actions.updateAssetsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updateAssetsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updateAssetsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}
/* Delete Assets Sagas */
function* handleDeleteAssetsRequest() {
    const action = yield take(actions.deleteAssetsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.deleteAssets, dataParams);
        if (res.isError) {
            yield put(actions.deleteAssetsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deleteAssetsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deleteAssetsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Assets In Stock Sagas */
function* handleAssetsInStockRequest() {
    const action = yield take(actions.assetsInStockRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.assetsInStock, dataParams);
        if (res.isError) {
            yield put(actions.assetsInStockError(res));

        } else {
            yield put(actions.assetsInStockSuccess(res));

        }
    } catch (error) {
        yield put(actions.assetsInStockError());

    }
}


/* Assign Asset To Employee Sagas */
function* handleAssignAssetToEmployeeRequest() {
    const action = yield take(actions.assignAssetToEmployeeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.assignAssetToEmployee, dataParams);
        if (res.isError) {
            yield put(actions.assignAssetToEmployeeError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.assignAssetToEmployeeSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

        }
    } catch (error) {
        yield put(actions.assignAssetToEmployeeError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    }
}

/* get Assign Asset Sagas */
function* handleGetAssignAssetRequest() {
    const action = yield take(actions.getAssignAssetRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.getAssignAsset, dataParams);
        if (res.isError) {
            yield put(actions.getAssignAssetError(res));

        } else {
            yield put(actions.getAssignAssetSuccess(res));

        }
    } catch (error) {
        yield put(actions.getAssignAssetError());

    }
}

/* get Assign Asset Sagas */
function* handleReleaseAssetsRequest() {
    const action = yield take(actions.releaseAssetsRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.releaseAssets, dataParams);
        if (res.isError) {
            yield put(actions.releaseAssetsError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.releaseAssetsSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

        }
    } catch (error) {
        yield put(actions.releaseAssetsError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    }
}

/* get Assign Asset Sagas */
function* handleAssetUndertakingRequest() {
    const action = yield take(actions.assetUndertakingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.assetUndertaking, dataParams);
        if (res.isError) {
            yield put(actions.assetUndertakingError(res));

        } else {
            yield put(actions.assetUndertakingSuccess(res));

        }
    } catch (error) {
        yield put(actions.assetUndertakingError());

    }
}



/*get Asset Undertaking Sagas */
function* handleGetAssetUndertakingRequest() {
    const action = yield take(actions.getAssetUndertakingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.getAssetUndertaking, dataParams);
        if (res.isError) {
            yield put(actions.getAssetUndertakingError(res));
        } else {
            yield put(actions.getAssetUndertakingSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAssetUndertakingError());

    }
}


/*Asset Request Sagas */
function* handleAssetRequestRequest() {
    const action = yield take(actions.assetRequestRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.assetRequest, dataParams);
        if (res.isError) {
            yield put(actions.assetRequestError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.assetRequestSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.assetRequestError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    }
}

/*get Asset Request Data Sagas */
function* handleGetAssetRequestDataRequest() {
    const action = yield take(actions.getAssetRequestDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.getAssetRequestData, dataParams);
        if (res.isError) {
            yield put(actions.getAssetRequestDataError(res));
        } else {
            yield put(actions.getAssetRequestDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getAssetRequestDataError());

    }
}



/*Assigned Asset Sagas */
function* handleAssignedAssetRequest() {
    const action = yield take(actions.assignedAssetRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.assignedAsset, dataParams);
        if (res.isError) {
            yield put(actions.assignedAssetError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.assignedAssetSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.assignedAssetError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    }
}

/*Assigned Asset Sagas */
function* handleMyAssetRequest() {
    const action = yield take(actions.myAssetRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.myAsset, dataParams);
        if (res.isError) {
            yield put(actions.myAssetError(res));

        } else {
            yield put(actions.myAssetSuccess(res));

        }
    } catch (error) {
        yield put(actions.myAssetError());


    }
}

/*Assigned Asset Sagas */
function* handleGetAssetApprovalRequest() {
    const action = yield take(actions.getAssetApprovalRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.getAssetApproval, dataParams);
        if (res.isError) {
            yield put(actions.getAssetApprovalError(res));

        } else {
            yield put(actions.getAssetApprovalSuccess(res));

        }
    } catch (error) {
        yield put(actions.getAssetApprovalError());


    }
}


/*Assigned Asset Sagas */
function* handleApproveAssetRequestRequest() {
    const action = yield take(actions.approveAssetRequestRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.approveAssetRequest, dataParams);
        if (res.isError) {
            yield put(actions.approveAssetRequestError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.approveAssetRequestSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

        }
    } catch (error) {
        yield put(actions.approveAssetRequestError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));


    }
}


/*Get Under Taking Sagas */
function* handleGetUnderTakingRequest() {
    const action = yield take(actions.getUnderTakingRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.getUnderTaking, dataParams);
        if (res.isError) {
            yield put(actions.getUnderTakingError(res));

        } else {
            yield put(actions.getUnderTakingSuccess(res));

        }
    } catch (error) {
        yield put(actions.getUnderTakingError());
    }
}


/*Get Under Taking Sagas */
function* handleAssetSummaryRequest() {
    const action = yield take(actions.assetSummaryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.assetSummary, dataParams);
        if (res.isError) {
            yield put(actions.assetSummaryError(res));

        } else {
            yield put(actions.assetSummarySuccess(res));

        }
    } catch (error) {
        yield put(actions.assetSummaryError());
    }
}

/*Get Under Taking Sagas */
function* handleCancelAssetRequestRequest() {
    const action = yield take(actions.cancelAssetRequestRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.cancelAssetRequest, dataParams);
        if (res.isError) {
            yield put(actions.cancelAssetRequestError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.cancelAssetRequestSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));

        }
    } catch (error) {
        yield put(actions.cancelAssetRequestError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/*Get Under Taking Sagas */
function* handleTeamAssetRequest() {
    const action = yield take(actions.teamAssetRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(assetsManagementService.teamAsset, dataParams);
        if (res.isError) {
            yield put(actions.teamAssetError(res));

        } else {
            yield put(actions.teamAssetSuccess(res));

        }
    } catch (error) {
        yield put(actions.teamAssetError());
    }
}







/* -----------Watchers------------- */
function* handleAddAssetsWatcher() {
    yield takeEvery(
        actions.addAssetsRequest,
        handleAddAssetsRequest,
    );
}

function* handleGetAllAssetsListWatcher() {
    yield takeEvery(
        actions.getAllAssetsListRequest,
        handleGetAllAssetsListRequest,
    );
}

function* handleGetAssetsWatcher() {
    yield takeEvery(
        actions.getAssetsRequest,
        handleGetAssetsRequest,
    );
}

function* handleUpdateAssetsWatcher() {
    yield takeEvery(
        actions.updateAssetsRequest,
        handleUpdateAssetsRequest,
    );
}

function* handleDeleteAssetsWatcher() {
    yield takeEvery(
        actions.deleteAssetsRequest,
        handleDeleteAssetsRequest,
    );
}

function* handleAssetsInStockWatcher() {
    yield takeEvery(
        actions.assetsInStockRequest,
        handleAssetsInStockRequest,
    );
}

function* handleAssignAssetToEmployeeWatcher() {
    yield takeEvery(
        actions.assignAssetToEmployeeRequest,
        handleAssignAssetToEmployeeRequest,
    );
}

function* handleGetAssignAssetWatcher() {
    yield takeEvery(
        actions.getAssignAssetRequest,
        handleGetAssignAssetRequest,
    );
}

function* handleReleaseAssetsWatcher() {
    yield takeEvery(
        actions.releaseAssetsRequest,
        handleReleaseAssetsRequest,
    );
}

function* handleAssetUndertakingWatcher() {
    yield takeEvery(
        actions.assetUndertakingRequest,
        handleAssetUndertakingRequest,
    );
}

function* handleGetAssetUndertakingWatcher() {
    yield takeEvery(
        actions.getAssetUndertakingRequest,
        handleGetAssetUndertakingRequest,
    );
}

function* handleAssetRequestWatcher() {
    yield takeEvery(
        actions.assetRequestRequest,
        handleAssetRequestRequest,
    );
}

function* handleGetAssetRequestDataWatcher() {
    yield takeEvery(
        actions.getAssetRequestDataRequest,
        handleGetAssetRequestDataRequest,
    );
}
function* handleAssignedAssetWatcher() {
    yield takeEvery(
        actions.assignedAssetRequest,
        handleAssignedAssetRequest,
    );
}

function* handleMyAssetWatcher() {
    yield takeEvery(
        actions.myAssetRequest,
        handleMyAssetRequest,
    );
}

function* handleGetAssetApprovalWatcher() {
    yield takeEvery(
        actions.getAssetApprovalRequest,
        handleGetAssetApprovalRequest,
    );
}

function* handleApproveAssetRequestWatcher() {
    yield takeEvery(
        actions.approveAssetRequestRequest,
        handleApproveAssetRequestRequest,
    );
}


function* handleGetUnderTakingWatcher() {
    yield takeEvery(
        actions.getUnderTakingRequest,
        handleGetUnderTakingRequest,
    );
}


function* handleAssetSummaryWatcher() {
    yield takeEvery(
        actions.assetSummaryRequest,
        handleAssetSummaryRequest,
    );
}

function* handleCancelAssetRequestWatcher() {
    yield takeEvery(
        actions.cancelAssetRequestRequest,
        handleCancelAssetRequestRequest,
    );
}


function* handleTeamAssetWatcher() {
    yield takeEvery(
        actions.teamAssetRequest,
        handleTeamAssetRequest,
    );
}




function* rootAssetsSaga() {
    yield all([
        handleAddAssetsRequest(),
        handleAddAssetsWatcher(),

        handleGetAllAssetsListRequest(),
        handleGetAllAssetsListWatcher(),

        handleGetAssetsRequest(),
        handleGetAssetsWatcher(),

        handleUpdateAssetsRequest(),
        handleUpdateAssetsWatcher(),

        handleDeleteAssetsRequest(),
        handleDeleteAssetsWatcher(),

        handleAssetsInStockRequest(),
        handleAssetsInStockWatcher(),

        handleAssignAssetToEmployeeRequest(),
        handleAssignAssetToEmployeeWatcher(),


        handleGetAssignAssetRequest(),
        handleGetAssignAssetWatcher(),

        handleReleaseAssetsRequest(),
        handleReleaseAssetsWatcher(),

        handleAssetUndertakingRequest(),
        handleAssetUndertakingWatcher(),

        handleGetAssetUndertakingRequest(),
        handleGetAssetUndertakingWatcher(),

        handleAssetRequestRequest(),
        handleAssetRequestWatcher(),

        handleGetAssetRequestDataRequest(),
        handleGetAssetRequestDataWatcher(),

        handleAssignedAssetRequest(),
        handleAssignedAssetWatcher(),

        handleMyAssetRequest(),
        handleMyAssetWatcher(),

        handleApproveAssetRequestRequest(),
        handleApproveAssetRequestWatcher(),

        handleGetAssetApprovalRequest(),
        handleGetAssetApprovalWatcher(),

        handleGetUnderTakingRequest(),
        handleGetUnderTakingWatcher(),

        handleAssetSummaryRequest(),
        handleAssetSummaryWatcher(),

        handleCancelAssetRequestRequest(),
        handleCancelAssetRequestWatcher(),

        
        handleTeamAssetRequest(),
        handleTeamAssetWatcher(),

    ]);
}

export default rootAssetsSaga;
